(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skip-to-content-link"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__veerySkipLink) return;
    window.__veerySkipLink = true;

    function soltar() {
      var activo = document.activeElement;
      if (activo && activo.classList && activo.classList.contains('skip-to-content-link')) {
        activo.blur();
      }
    }

    window.addEventListener('wheel', soltar, { passive: true });
    window.addEventListener('touchmove', soltar, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veery-escala"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var PARED = { ancho: 340, alto: 250 };
  var SUELO_MARGEN = 8;

  var MUEBLES = {
    sofa:    { t: 'Sofa',       w: 200, alto: 85 },
    consola: { t: 'Console',    w: 110, alto: 80 },
    nada:    { t: 'Empty wall', w: 0,   alto: 0 }
  };
  var MARCOS = {
    sin:    { t: 'Print only', color: null },
    negro:  { t: 'Black',      color: '#1A1918' },
    blanco: { t: 'White',      color: '#F1EFE8' },
    roble:  { t: 'Natural wood', color: '#C8A272' },
    oscuro: { t: 'Dark wood',  color: '#6B4E32' }
  };
  var PAREDES = { crema: '#EFEDE6', blanco: '#F7F7F5', arena: '#E4DCCC', verde: '#DDE3DB', azul: '#DCE4EF' };
  var PAREDES_T = { crema: 'Cream', blanco: 'White', arena: 'Sand', verde: 'Sage', azul: 'Blue' };
  var PERSONAS = [155, 170, 185];

  function mcd(a, b) { return b ? mcd(b, a % b) : a; }

  function claveMarcoTexto(v) {
    v = String(v || '').toLowerCase();
    if (/print only|unframed|no frame|sin marco|poster only|sans cadre|affiche seule/.test(v)) return 'sin';
    if (/dark|walnut|oscur|nogal|foncé|fonce|noyer/.test(v)) return 'oscuro';
    if (/oak|roble|natural|naturel|wood|chêne|chene/.test(v)) return 'roble';
    if (/black|negro|noir/.test(v)) return 'negro';
    if (/white|blanco|blanc/.test(v)) return 'blanco';
    return 'sin';
  }

  function leerUnidadGuardada() {
    try { return window.localStorage.getItem('veery:unidad'); } catch (e) { return null; }
  }
  function guardarUnidad(u) {
    try { window.localStorage.setItem('veery:unidad', u); } catch (e) {  }
  }

  function fieldsetPorOpcion(handle, nombre) {
    var i;
    if (nombre) {
      var radios = document.querySelectorAll('variant-picker input[data-option-name]');
      for (i = 0; i < radios.length; i++) {
        var fs = radios[i].getAttribute('data-option-name') === nombre ? radios[i].closest('fieldset') : null;
        if (fs) return fs;
      }
    }
    if (!handle) return null;
    var sufijo = '-' + handle;
    var grupos = document.querySelectorAll('.variant-option[data-option-id]');
    for (i = 0; i < grupos.length; i++) {
      var id = grupos[i].getAttribute('data-option-id') || '';
      if (id.slice(-sufijo.length) === sufijo) return grupos[i];
    }
    return null;
  }
  function fieldsetTallaLeyenda() {
    var legends = document.querySelectorAll('fieldset legend');
    for (var i = 0; i < legends.length; i++) {
      if (/\bsize\b/i.test(legends[i].textContent)) return legends[i].closest('fieldset');
    }
    return null;
  }

  function iniciar(raiz) {
    if (raiz.__vescListo) return;
    var nodoDatos = raiz.querySelector('[data-vesc-datos]');
    if (!nodoDatos) return;
    var datos;
    try { datos = JSON.parse(nodoDatos.textContent); } catch (e) { return; }
    var TX = datos.textos || {};
    Object.keys(MUEBLES).forEach(function (k) { if (TX.muebles && TX.muebles[k]) MUEBLES[k].t = TX.muebles[k]; });
    Object.keys(MARCOS).forEach(function (k) { if (TX.marcos && TX.marcos[k]) MARCOS[k].t = TX.marcos[k]; });
    Object.keys(PAREDES_T).forEach(function (k) { if (TX.paredes && TX.paredes[k]) PAREDES_T[k] = TX.paredes[k]; });
    raiz.__vescListo = true;

    var TALLAS = [];
    datos.tallas.forEach(function (label) {
      var m = String(label).match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      if (!m) return;
      var w = +m[1], h = +m[2], d = mcd(Math.round(w), Math.round(h)) || 1;
      var t = { id: String(label).trim(), w: w, h: h, cmW: w, cmH: h, ratio: Math.round(w / d) + ':' + Math.round(h / d) };
      var p = String((datos.pulgadas || {})[label] || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      if (p) {
        t.inW = +p[1];
        t.inH = +p[2];
        if (datos.na) { t.w = t.inW * 2.54; t.h = t.inH * 2.54; }
      }
      TALLAS.push(t);
    });
    if (!TALLAS.length) return;
    var VARIANTES = datos.variantes || [];
    var OPC = datos.opciones || {};
    var NOM = datos.nombres || {};
    var FRASES = datos.frases || {};
    var MARCO_DE = {};
    var FRASE_MARCO = {};
    var MAYUSCULAS = datos.mayusculas === true;
    function marcoEnFrase(n) { return MAYUSCULAS ? n : n.toLowerCase(); }
    (datos.marcos || []).forEach(function (m) {
      var k = m.u ? 'sin' : claveMarcoTexto(m.h);
      MARCO_DE[String(m.l).toLowerCase().trim()] = k;
      if (!FRASE_MARCO[k]) FRASE_MARCO[k] = String(m.l);
    });
    function claveMarco(v) {
      var partes = String(v || '').split(' / ');
      for (var i = partes.length - 1; i >= 0; i--) {
        var k = MARCO_DE[partes[i].toLowerCase().trim()];
        if (k) return k;
      }
      return claveMarcoTexto(v);
    }
    function fieldsetTalla() { return fieldsetPorOpcion(OPC.talla, NOM.talla) || fieldsetTallaLeyenda(); }
    function fieldsetAcabado() { return fieldsetPorOpcion(OPC.acabado, NOM.acabado) || fieldsetPorOpcion('finish'); }

    var guardada = leerUnidadGuardada();
    var e = {
      talla: TALLAS[Math.min(3, TALLAS.length - 1)].id,
      fantasma: null,
      orient: datos.apaisada ? 'h' : 'v',
      marco: 'sin',
      mueble: 'sofa',
      pared: 'blanco',
      persona: 170,
      unidad: guardada === 'in' || guardada === 'cm' ? guardada : datos.unidad
    };

    var lienzo = raiz.querySelector('[data-vesc-lienzo]');
    var resumen = raiz.querySelector('[data-vesc-resumen]');
    var clipId = datos.uid + '-clip';

    var GUIA = datos.guia === true;
    var muro = GUIA ? raiz.querySelector('[data-vesc-muro]') : null;
    var CAPA = GUIA ? {
      persona: raiz.querySelector('[data-vesc-g="persona"]'),
      cabeza: raiz.querySelector('[data-vesc-g="persona"] .vesc__g-cabeza'),
      cuerpo: raiz.querySelector('[data-vesc-g="persona"] .vesc__g-cuerpo'),
      sofa: raiz.querySelector('[data-vesc-g="sofa"]'),
      consola: raiz.querySelector('[data-vesc-g="consola"]'),
      obra: raiz.querySelector('[data-vesc-obra]'),
      lamina: raiz.querySelector('[data-vesc-lamina]'),
      cota: raiz.querySelector('[data-vesc-cota]'),
      etPersona: raiz.querySelector('[data-vesc-et="persona"]'),
      etCota: raiz.querySelector('[data-vesc-et="cota"]'),
      etMueble: raiz.querySelector('[data-vesc-et="mueble"]'),
      etAncho: raiz.querySelector('[data-vesc-et="ancho"]'),
      etAlto: raiz.querySelector('[data-vesc-et="alto"]')
    } : null;
    var MUEBLES_GUIA = { sofa: { w: 200, alto: 85 }, consola: { w: 120, alto: 80 }, nada: { w: 0, alto: 0 } };

    function pxs(v) { return Math.round(v * 10) / 10 + 'px'; }
    function coloca(el, x, y, w, h, ancla) {
      if (!el) return;
      el.style.transform = 'translate(' + pxs(x) + ', ' + pxs(y) + ')' + (ancla || '');
      if (w != null) el.style.width = pxs(w);
      if (h != null) el.style.height = pxs(h);
    }
    function nombreMarco(k) {
      if (!GUIA || !FRASE_MARCO[k]) return MARCOS[k].t;
      var n = String(FRASE_MARCO[k]);
      return n.charAt(0).toUpperCase() + (MAYUSCULAS ? n.slice(1) : n.slice(1).toLowerCase());
    }
    function rotuloChip(t) {
      if (e.unidad === 'in' && t.inW) return t.inW + '×' + t.inH;
      return e.unidad === 'in' ? Math.round(t.w / 2.54) + '×' + Math.round(t.h / 2.54) : Math.round(t.cmW) + '×' + Math.round(t.cmH);
    }
    function textoElegir(t, agotada) {
      return agotada ? datos.agotado : String(FRASES.elegir || '__size__').replace('__size__', rotuloChip(t) + (e.unidad === 'in' ? '″' : ''));
    }
    function estado() {
      var v = varianteActual();
      var agotada = !!(v && v.d === false);
      return { talla: e.talla, marco: e.marco, unidad: e.unidad, mueble: e.mueble, persona: e.persona, precio: v ? v.p : null, agotada: agotada, texto: textoElegir(tallaActual(), agotada) };
    }
    function quieto(fn) {
      raiz.classList.add('vesc--quieto');
      fn();
      if (CAPA && CAPA.obra) void CAPA.obra.offsetWidth;
      raiz.classList.remove('vesc--quieto');
    }

    function dibujaGuia(t, d, m, mk) {
      var c = CAPA;
      var W = muro ? muro.clientWidth : 0, H = muro ? muro.clientHeight : 0;
      if (!(W > 0 && H > 0)) return;
      var g = MUEBLES_GUIA[e.mueble] || MUEBLES_GUIA.nada;
      var ancho = g.w || 60;
      var k = Math.min((H - 66) / 230, (W - 48) / (46 + 40 + ancho + 20));
      var px = function (cm) { return cm * k; };
      var y = function (cm) { return H - 26 - px(cm); };
      var alto = e.persona;
      var xp = Math.max(24, W * 0.07), pw = px(46);
      var cx = Math.min(W - px(ancho) / 2 - 12, Math.max(xp + pw + px(40) + px(ancho) / 2, W * 0.58));
      var fw = mk.color ? Math.max(3, px(+datos.grosor)) : 0;
      var aw = px(d.w) + fw * 2, ah = px(d.h) + fw * 2;
      var abajo = Math.max(g.alto + 18, 145 - d.h / 2);
      var arriba = y(abajo) - ah;

      coloca(c.persona, xp, y(alto), pw, px(alto));
      if (c.cabeza) { c.cabeza.style.width = pxs(px(23)); c.cabeza.style.height = pxs(px(23)); }
      if (c.cuerpo) c.cuerpo.style.top = pxs(px(27));
      if (c.etPersona) {
        c.etPersona.textContent = estatura(alto);
        coloca(c.etPersona, xp + pw + 8, y(alto) - 2);
      }

      var piezas = { sofa: c.sofa, consola: c.consola };
      Object.keys(piezas).forEach(function (n) {
        var el = piezas[n];
        if (!el) return;
        el.hidden = e.mueble !== n;
        if (e.mueble === n) coloca(el, cx - px(g.w) / 2, y(g.alto), px(g.w), px(g.alto));
      });
      if (c.etMueble) {
        c.etMueble.hidden = !g.w;
        if (g.w) {
          c.etMueble.textContent = m.t + ' · ' + med(g.w);
          coloca(c.etMueble, cx, y(g.alto) + px(g.alto) / 2, null, null, ' translateX(-50%)');
        }
      }

      coloca(c.obra, cx - aw / 2, arriba, aw, ah);
      if (c.obra) c.obra.style.backgroundColor = fw ? mk.color : 'transparent';
      if (c.lamina) {
        var borde = pxs(fw);
        c.lamina.style.top = borde;
        c.lamina.style.right = borde;
        c.lamina.style.bottom = borde;
        c.lamina.style.left = borde;
        c.lamina.classList.toggle('vesc__obra-lamina--obra', !!datos.imagen);
        c.lamina.style.backgroundImage = datos.imagen && raiz.__vescSrc ? 'url("' + raiz.__vescSrc + '")' : '';
      }

      var lx = Math.round(cx - aw / 2 - 18);
      coloca(c.cota, lx, arriba, null, y(0) - arriba);
      if (c.etCota) {
        c.etCota.textContent = med(Math.round(abajo + d.h));
        coloca(c.etCota, lx - 8, (arriba + y(0)) / 2 - 10, null, null, ' translateX(-100%)');
      }

      var lados = ladosLamina(t);
      if (c.etAncho) {
        c.etAncho.textContent = lados[0];
        coloca(c.etAncho, cx, Math.max(4, arriba - 6), null, null, ' translate(-50%, -100%)');
      }
      if (c.etAlto) {
        c.etAlto.textContent = lados[1];
        coloca(c.etAlto, cx + aw / 2 + 8, arriba + ah / 2, null, null, ' translateY(-50%)');
      }
    }

    function pintaGuia() {
      var t = tallaActual(), d = orientada(t), m = MUEBLES[e.mueble], mk = MARCOS[e.marco];
      dibujaGuia(t, d, m, mk);

      var v = varianteActual();
      var agotada = !!(v && v.d === false);
      var btn = raiz.querySelector('[data-vesc-elegir]');
      if (btn) {
        btn.disabled = agotada;
        var texto = btn.querySelector('[data-vesc-elegir-texto]');
        var precio = btn.querySelector('[data-vesc-elegir-precio]');
        if (texto) texto.textContent = textoElegir(t, agotada);
        if (precio) {
          precio.hidden = agotada || !v;
          precio.lastChild.textContent = v ? v.p : '';
        }
      }

      var gr = mk.color ? +datos.grosor : 0;
      var fraseMarco = gr ? String(FRASES.conMarco || '').replace('__frame__', marcoEnFrase(String(FRASE_MARCO[e.marco] || mk.t))) : '';
      var fraseMueble = m.w ? String(FRASES[e.mueble] || '').replace('__w__', med((MUEBLES_GUIA[e.mueble] || m).w)) : String(FRASES.nada || '');
      var frase = String(FRASES.resumen || '')
        .replace('__size__', par(d.w, d.h))
        .replace('__withframe__', fraseMarco)
        .replace('__wall__', med(PARED.ancho))
        .replace('__furniture__', fraseMueble)
        .replace('__person__', estatura(e.persona));
      if (resumen.textContent !== frase) resumen.textContent = frase;

      sincronizaChips();
      raiz.dispatchEvent(new CustomEvent('vesc:estado', { bubbles: true, detail: estado() }));
    }

    function estatura(cm) {
      if (e.unidad !== 'in') return Math.round(cm) + ' cm';
      var pul = Math.round(cm / 2.54);
      return Math.floor(pul / 12) + '′' + (pul % 12) + '″';
    }
    function med(cm) {
      return e.unidad === 'in' ? Math.round(cm / 2.54) + ' in' : Math.round(cm) + ' cm';
    }
    function par(w, h) {
      return e.unidad === 'in'
        ? (w / 2.54).toFixed(1) + ' × ' + (h / 2.54).toFixed(1) + '″'
        : Math.round(w) + ' × ' + Math.round(h) + ' cm';
    }
    function ladosLamina(t) {
      var w, h;
      if (e.unidad === 'in') {
        w = t.inW || Math.round(t.cmW / 2.54);
        h = t.inH || Math.round(t.cmH / 2.54);
      } else {
        w = Math.round(t.cmW);
        h = Math.round(t.cmH);
      }
      var u = e.unidad === 'in' ? ' in' : ' cm';
      return e.orient === 'h' ? [h + u, w + u] : [w + u, h + u];
    }
    function rotuloTalla(t) {
      if (e.unidad === 'in' && t.inW) return t.inW + ' × ' + t.inH + '″';
      return e.unidad === 'in'
        ? Math.round(t.w / 2.54) + ' × ' + Math.round(t.h / 2.54) + '″'
        : Math.round(t.cmW) + ' × ' + Math.round(t.cmH);
    }
    function tallaActual() {
      for (var i = 0; i < TALLAS.length; i++) if (TALLAS[i].id === e.talla) return TALLAS[i];
      return TALLAS[0];
    }
    function orientada(t) {
      return e.orient === 'h' ? { w: t.h, h: t.w } : { w: t.w, h: t.h };
    }
    function varianteActual() {
      var talla = e.talla.toLowerCase();
      for (var i = 0; i < VARIANTES.length; i++) {
        var t = String(VARIANTES[i].t).toLowerCase();
        if (t.indexOf(talla) > -1 && claveMarco(t) === e.marco) return VARIANTES[i];
      }
      return null;
    }

    function r(x, y, w, h, rx, cls) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '"' + (rx ? ' rx="' + rx + '"' : '') + ' class="' + cls + '"/>';
    }
    function rArriba(x, y, w, h, rx, cls) {
      return '<path class="' + cls + '" d="M' + x + ',' + (y + h)
        + ' V' + (y + rx) + ' Q' + x + ',' + y + ' ' + (x + rx) + ',' + y
        + ' H' + (x + w - rx) + ' Q' + (x + w) + ',' + y + ' ' + (x + w) + ',' + (y + rx)
        + ' V' + (y + h) + ' Z"/>';
    }
    function sofa(x, base, w, h) {
      var Y = function (cm) { return base - cm; };
      var pata = 7, baseAlto = 30, asiento = 44, brazoAlto = 62, brazo = 20;
      var ix = x + brazo, iw = w - brazo * 2, hueco = 2.5;
      var ancho = (iw - hueco * 4) / 3, g = '', i;

      g += rArriba(ix - 5, Y(h), iw + 10, h - asiento + 3, 7, 'vesc__sofa-respaldo');
      for (i = 0; i < 3; i++) {
        g += r(ix + hueco + i * (ancho + hueco), Y(h - 5), ancho, (h - 5) - asiento + 4, 7, 'vesc__sofa-cojin');
      }
      g += r(ix, Y(baseAlto), iw, baseAlto - pata, 1.5, 'vesc__sofa-base');
      for (i = 0; i < 3; i++) {
        g += r(ix + hueco + i * (ancho + hueco), Y(asiento), ancho, asiento - baseAlto + 1, 3.5, 'vesc__sofa-cojin');
      }
      g += rArriba(x, Y(brazoAlto), brazo, brazoAlto - pata, 8, 'vesc__sofa-brazo');
      g += rArriba(x + w - brazo, Y(brazoAlto), brazo, brazoAlto - pata, 8, 'vesc__sofa-brazo');
      g += '<path class="vesc__sofa-pata" d="M' + (x + 5) + ',' + Y(pata) + ' h7 l-2,' + pata + ' h-3 z"/>';
      g += '<path class="vesc__sofa-pata" d="M' + (x + w - 12) + ',' + Y(pata) + ' h7 l-2,' + pata + ' h-3 z"/>';
      return g;
    }
    function consola(x, base, w, h) {
      var top = base - h, tabla = 6, g = '';
      g += r(x, top, w, tabla, 1.5, 'vesc__mueble');
      g += r(x + 4, top + tabla, w - 8, h * 0.42, 1.5, 'vesc__mueble-2');
      g += '<line x1="' + (x + 4) + '" y1="' + (top + tabla + h * 0.21) + '" x2="' + (x + w - 4) + '" y2="' + (top + tabla + h * 0.21) + '" class="vesc__costura"/>';
      g += r(x + 5, top + tabla, 5, h - tabla, 0, 'vesc__mueble');
      g += r(x + w - 10, top + tabla, 5, h - tabla, 0, 'vesc__mueble');
      return g;
    }
    function persona(x, base, H) {
      var top = base - H, f = function (p) { return top + H * p; };
      var hombro = H * 0.19, cadera = H * 0.155, redondeo = H * 0.02, g = '';
      g += '<circle cx="' + x + '" cy="' + f(0.065) + '" r="' + (H * 0.065) + '" class="vesc__persona"/>';
      g += r(x - H * 0.028, f(0.118), H * 0.056, H * 0.045, 0, 'vesc__persona');
      g += '<path class="vesc__persona" d="M' + (x - hombro / 2) + ',' + f(0.175)
        + ' h' + hombro
        + ' a' + redondeo + ',' + redondeo + ' 0 0 1 ' + redondeo + ',' + redondeo
        + ' L' + (x + cadera / 2) + ',' + f(0.52)
        + ' h' + (-cadera)
        + ' L' + (x - hombro / 2 - redondeo) + ',' + f(0.195)
        + ' a' + redondeo + ',' + redondeo + ' 0 0 1 ' + redondeo + ',' + (-redondeo) + ' z"/>';
      g += r(x - hombro / 2 - H * 0.042, f(0.185), H * 0.042, H * 0.27, H * 0.021, 'vesc__persona');
      g += r(x + hombro / 2, f(0.185), H * 0.042, H * 0.27, H * 0.021, 'vesc__persona');
      g += r(x - cadera / 2, f(0.50), H * 0.071, H * 0.50, H * 0.032, 'vesc__persona');
      g += r(x + cadera / 2 - H * 0.071, f(0.50), H * 0.071, H * 0.50, H * 0.032, 'vesc__persona');
      return g;
    }

    function pinta() {
      if (GUIA) { pintaGuia(); return; }
      var W = PARED.ancho, H = PARED.alto, base = H - SUELO_MARGEN;
      var t = tallaActual(), d = orientada(t), m = MUEBLES[e.mueble], mk = MARCOS[e.marco];
      var gr = mk.color ? +datos.grosor : 0;

      var px = 26, huecoIzq = px + 18, huecoDer = W - 6;
      var cx = (huecoIzq + huecoDer) / 2;
      var mx = m.w ? cx - m.w / 2 : 0;

      var abajo = m.w ? (base - m.alto - 22) : (base - 150 + d.h / 2);
      var arriba = abajo - d.h;
      var lx = cx - d.w / 2;
      var centro = base - (arriba + d.h / 2);

      var s = '';
      s += '<rect x="0" y="0" width="' + W + '" height="' + H + '" class="vesc__pared"/>';
      s += r(0, base, W, H - base, 0, 'vesc__suelo');
      s += r(0, base - 7, W, 7, 0, 'vesc__zocalo');
      s += '<line x1="0" y1="' + (base - 7) + '" x2="' + W + '" y2="' + (base - 7) + '" class="vesc__zocalo-l"/>';

      if (e.mueble === 'sofa') s += sofa(mx, base, m.w, m.alto);
      if (e.mueble === 'consola') s += consola(mx, base, m.w, m.alto);
      if (m.w) {
        s += '<text x="' + (mx + m.w / 2) + '" y="' + (base - m.alto * 0.62) + '" text-anchor="middle" class="vesc__rotulo">' + m.t + ' · ' + med(m.w) + '</text>';
      }

      s += persona(px, base, e.persona);
      s += '<text x="' + (px + 15) + '" y="' + (base - e.persona + 9) + '" class="vesc__rotulo">' + med(e.persona) + '</text>';

      if (e.fantasma && e.fantasma !== e.talla) {
        var tf = null;
        for (var i = 0; i < TALLAS.length; i++) if (TALLAS[i].id === e.fantasma) tf = TALLAS[i];
        if (tf) {
          var df = orientada(tf);
          var fAbajo = m.w ? abajo : (base - 150 + df.h / 2);
          s += '<rect x="' + (cx - df.w / 2) + '" y="' + (fAbajo - df.h) + '" width="' + df.w + '" height="' + df.h + '" class="vesc__fantasma"/>';
        }
      }

      s += r(lx + 1.5, arriba + 1.5, d.w + gr * 2 - 1, d.h + gr * 2 - 1, 0, 'vesc__sombra');
      if (gr) s += '<rect x="' + (lx - gr) + '" y="' + (arriba - gr) + '" width="' + (d.w + gr * 2) + '" height="' + (d.h + gr * 2) + '" fill="' + mk.color + '"/>';
      if (datos.imagen && raiz.__vescSrc) {
        s += '<clipPath id="' + clipId + '"><rect x="' + lx + '" y="' + arriba + '" width="' + d.w + '" height="' + d.h + '"/></clipPath>';
        s += r(lx, arriba, d.w, d.h, 0, 'vesc__papel');
        s += '<image href="' + raiz.__vescSrc + '" x="' + lx + '" y="' + arriba + '" width="' + d.w + '" height="' + d.h + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + clipId + ')"/>';
      } else if (datos.imagen) {
        s += r(lx, arriba, d.w, d.h, 0, 'vesc__papel');
      } else {
        s += r(lx, arriba, d.w, d.h, 0, 'vesc__vacia');
      }

      s += '<line x1="' + (lx - gr - 9) + '" y1="' + (arriba + d.h / 2) + '" x2="' + (lx - gr - 9) + '" y2="' + base + '" class="vesc__cota"/>';
      s += '<text x="' + (lx - gr - 12) + '" y="' + (base - centro / 2) + '" text-anchor="end" class="vesc__cota-t">' + med(centro) + '</text>';

      lienzo.style.setProperty('--vesc-muro', PAREDES[e.pared]);
      lienzo.innerHTML = s;

      var v = varianteActual();

      var btn = raiz.querySelector('[data-vesc-elegir]');
      if (btn) {
        var agotada = v && v.d === false;
        btn.disabled = !!agotada;
        var base = btn.querySelector('[data-vesc-elegir-base]');
        var detalle = btn.querySelector('[data-vesc-elegir-detalle]');
        if (base) base.textContent = agotada ? datos.agotado : btn.getAttribute('data-texto');
        if (detalle) detalle.textContent = agotada ? datos.agotado : String(FRASES.elegir || '__size__').replace('__size__', rotuloTalla(t)) + (v ? ' — ' + v.p : '');
      }

      var fraseMarco = gr ? String(FRASES.conMarco || '').replace('__frame__', marcoEnFrase(String(FRASE_MARCO[e.marco] || mk.t))) : '';
      var fraseMueble = m.w ? String(FRASES[e.mueble] || '').replace('__w__', med(m.w)) : String(FRASES.nada || '');
      resumen.textContent = String(FRASES.resumen || '')
        .replace('__size__', par(d.w, d.h))
        .replace('__withframe__', fraseMarco)
        .replace('__wall__', med(W))
        .replace('__furniture__', fraseMueble)
        .replace('__person__', estatura(e.persona));

      sincronizaChips();
    }

    function grupo(nombre, items, clase, alPulsar) {
      var c = raiz.querySelector('[data-vesc-grupo="' + nombre + '"]');
      if (!c) return;
      c.innerHTML = '';
      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vesc__chip' + (clase ? ' ' + clase : '') + (it.clase ? ' ' + it.clase : '');
        b.setAttribute('data-v', it.v);
        if (it.muestra) {
          if (it.color) b.style.backgroundColor = it.color;
          b.setAttribute('aria-label', it.t);
          b.title = it.t;
        } else {
          b.textContent = it.t;
        }
        b.addEventListener('click', function () { alPulsar(it.v); pinta(); });
        c.appendChild(b);
      });
    }

    function sincronizaChips() {
      var mapa = { talla: e.talla, marco: e.marco, mueble: e.mueble, pared: e.pared, persona: String(e.persona), unidad: e.unidad };
      Object.keys(mapa).forEach(function (k) {
        var bs = raiz.querySelectorAll('[data-vesc-grupo="' + k + '"] .vesc__chip');
        for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-pressed', bs[i].getAttribute('data-v') === mapa[k] ? 'true' : 'false');
      });
      var sm = raiz.querySelector('[data-vesc-sel="marco"]');
      if (sm) sm.textContent = GUIA ? nombreMarco(e.marco) : MARCOS[e.marco].t;
      var sp = raiz.querySelector('[data-vesc-sel="pared"]');
      if (sp) sp.textContent = PAREDES_T[e.pared];
      var bt = raiz.querySelectorAll('[data-vesc-grupo="talla"] .vesc__chip');
      for (var j = 0; j < bt.length; j++) {
        var t = null;
        for (var n = 0; n < TALLAS.length; n++) if (TALLAS[n].id === bt[j].getAttribute('data-v')) t = TALLAS[n];
        if (t) bt[j].textContent = rotuloChip(t);
      }
      var bp = raiz.querySelectorAll('[data-vesc-grupo="persona"] .vesc__chip');
      for (var q = 0; q < bp.length; q++) {
        var cm = +bp[q].getAttribute('data-v');
        bp[q].textContent = estatura(cm);
      }
    }

    grupo('talla', TALLAS.map(function (t) { return { t: t.id, v: t.id }; }), '', function (v) {
      if (v !== e.talla) { e.fantasma = e.talla; e.talla = v; }
    });
    var marcosObra = Object.keys(MARCOS).filter(function (k) {
      if (!VARIANTES.length) return true;
      for (var i = 0; i < VARIANTES.length; i++) if (claveMarco(VARIANTES[i].t) === k) return true;
      return false;
    });
    if (marcosObra.length && marcosObra.indexOf(e.marco) < 0) e.marco = marcosObra[0];
    grupo('marco', marcosObra.map(function (k) {
      return { t: GUIA ? nombreMarco(k) : MARCOS[k].t, v: k, muestra: true, color: MARCOS[k].color, clase: k === 'sin' ? 'vesc__chip--sin' : '' };
    }), 'vesc__chip--color', function (v) { e.marco = v; });
    grupo('mueble', Object.keys(MUEBLES).map(function (k) { return { t: MUEBLES[k].t, v: k }; }), 'vesc__chip--fino', function (v) { e.mueble = v; });
    grupo('persona', PERSONAS.map(function (p) { return { t: String(p), v: String(p) }; }), 'vesc__chip--fino', function (v) { e.persona = +v; });
    grupo('unidad', [{ t: 'cm', v: 'cm' }, { t: 'in', v: 'in' }], 'vesc__chip--fino', function (v) { e.unidad = v; guardarUnidad(v); });

    var btnElegir = raiz.querySelector('[data-vesc-elegir]');
    if (btnElegir && datos.elegir) {
      var marcar = function (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      };
      var aplicar = function (listo) {
        var cambiaTalla = false;
        var fsT = fieldsetTalla();
        if (fsT) {
          var radios = fsT.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radios.length; i++) {
            if (String(radios[i].value).toLowerCase().trim() === e.talla.toLowerCase() && !radios[i].checked) { marcar(radios[i]); cambiaTalla = true; break; }
          }
        }
        var hecho = false;
        var reloj = null;
        var seguir = function () {
          if (hecho) return;
          hecho = true;
          document.removeEventListener('variant:update', alLlegar);
          var fsA = fieldsetAcabado();
          if (fsA) {
            var ops = fsA.querySelectorAll('input[type="radio"]');
            for (var j = 0; j < ops.length; j++) {
              if (claveMarco(ops[j].value) === e.marco) {
                if (!ops[j].checked) marcar(ops[j]);
                break;
              }
            }
          }
          raiz.dispatchEvent(new CustomEvent('vesc:elegida', { bubbles: true, detail: { talla: e.talla, marco: e.marco } }));
          if (listo) listo();
        };
        var programar = function (ms) {
          window.clearTimeout(reloj);
          reloj = window.setTimeout(seguir, ms);
        };
        var alLlegar = function () { programar(0); };
        if (!cambiaTalla) { seguir(); return; }
        document.addEventListener('variant:update', alLlegar);
        programar(5000);
      };

      btnElegir.addEventListener('click', function () {
        if (btnElegir.disabled) return;
        var t = tallaActual();
        var etiqueta = rotuloTalla(t) + ' · ' + MARCOS[e.marco].t;
        var ev = new CustomEvent('vesc:elegir', {
          bubbles: true,
          cancelable: true,
          detail: { talla: e.talla, marco: e.marco, marcoEtiqueta: FRASE_MARCO[e.marco] || '', etiqueta: etiqueta, aplicar: aplicar }
        });
        raiz.dispatchEvent(ev);
        if (!ev.defaultPrevented) aplicar();
      });
    }

    raiz.__vesc = {
      estado: estado,
      fijar: function (talla, marco) {
        var buscada = String(talla || '').toLowerCase().trim();
        for (var i = 0; i < TALLAS.length; i++) if (TALLAS[i].id.toLowerCase() === buscada) { e.talla = TALLAS[i].id; e.fantasma = null; }
        if (marco) e.marco = claveMarco(marco);
        if (datos.imagen && !raiz.__vescSrc) raiz.__vescSrc = datos.imagen;
        pinta();
      },
      sincronizar: function () {
        var fsT = fieldsetTalla();
        if (fsT) {
          var c = fsT.querySelector('input:checked');
          if (c) for (var i = 0; i < TALLAS.length; i++) if (TALLAS[i].id.toLowerCase() === String(c.value).toLowerCase().trim()) { e.talla = TALLAS[i].id; e.fantasma = null; }
        }
        var fsA = fieldsetAcabado();
        if (fsA) {
          var ca = fsA.querySelector('input:checked');
          if (ca) e.marco = claveMarco(ca.value);
        }
        if (datos.imagen && !raiz.__vescSrc) raiz.__vescSrc = datos.imagen;
        pinta();
      }
    };

    if (!datos.elegir && datos.imagen) raiz.__vescSrc = datos.imagen;
    if (GUIA) {
      quieto(pinta);
      var cuadro = 0;
      var medida = muro ? muro.clientWidth + 'x' + muro.clientHeight : '';
      var alCambiar = function () {
        if (!raiz.isConnected) {
          window.removeEventListener('resize', alRedimensionar);
          return;
        }
        var ahora = muro ? muro.clientWidth + 'x' + muro.clientHeight : '';
        if (ahora === medida) return;
        medida = ahora;
        quieto(pinta);
      };
      var alRedimensionar = function () {
        if (cuadro) return;
        cuadro = window.requestAnimationFrame(function () {
          cuadro = 0;
          alCambiar();
        });
      };
      window.addEventListener('resize', alRedimensionar);
      raiz.addEventListener('veery:desmontar', function () {
        window.removeEventListener('resize', alRedimensionar);
        if (cuadro) window.cancelAnimationFrame(cuadro);
        cuadro = 0;
      }, { once: true });
      if (document.readyState !== 'complete') window.addEventListener('load', alCambiar);
    } else {
      pinta();
    }
  }

  function escanear() {
    var nodos = document.querySelectorAll('[data-vesc]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  window.VeeryEscala = { escanear: escanear };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', escanear);
  else escanear();
  document.addEventListener('shopify:section:load', escanear);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veery-guia-tallas"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function iniciar(raiz) {
    if (raiz.__vgtListo) return;
    raiz.__vgtListo = true;

    var escala = raiz.querySelector('[data-vesc]');
    var tarjetas = raiz.querySelectorAll('[data-vgt-marco]');

    function aplica(est) {
      if (!est) return;
      for (var j = 0; j < tarjetas.length; j++) {
        tarjetas[j].classList.toggle('is-activa', tarjetas[j].getAttribute('data-vgt-marco') === est.marco);
      }
    }

    function mideCabecera() {
      var cabecera = document.querySelector('header.shopify-section');
      var alto = cabecera ? Math.round(cabecera.getBoundingClientRect().height) : 0;
      if (alto > 0 && raiz.__vgtCabecera !== alto) {
        raiz.__vgtCabecera = alto;
        raiz.style.setProperty('--vgt-cabecera', alto + 'px');
      }
    }
    var cuadro = 0;
    function alRedimensionar() {
      if (!raiz.isConnected) {
        window.removeEventListener('resize', alRedimensionar);
        return;
      }
      if (cuadro) return;
      cuadro = window.requestAnimationFrame(function () {
        cuadro = 0;
        mideCabecera();
      });
    }

    raiz.addEventListener('vesc:estado', function (ev) {
      if (ev.target === escala) aplica(ev.detail);
    });

    mideCabecera();
    window.addEventListener('resize', alRedimensionar);
    if (document.readyState !== 'complete') window.addEventListener('load', mideCabecera);

    if (escala && escala.__vesc && escala.__vesc.estado) aplica(escala.__vesc.estado());
  }

  function escanear() {
    var nodos = document.querySelectorAll('[data-vgt]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', escanear);
  else escanear();
  document.addEventListener('shopify:section:load', escanear);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veery-mercado"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__veeryMercado) return;
    window.__veeryMercado = true;

    var escritorio = window.matchMedia('(min-width: 750px)');
    var guardado = { pais: '', idioma: '' };
    var borrador = { pais: '', idioma: '' };
    var idiomaAMano = false;
    var abridor = null;
    var overflowPrevio = null;

    var plano = function (txt) {
      try {
        return String(txt).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      } catch (e) {
        return String(txt).toLowerCase();
      }
    };

    var dialogo = function () {
      return document.getElementById('veery-mercado');
    };

    var visible = function (el) {
      if (!el || !el.getClientRects().length) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
    };

    var colocar = function () {
      var d = dialogo();
      if (!d) return;
      var caja = d.querySelector('.vme__caja');
      if (!caja) return;
      if (!escritorio.matches) {
        d.style.removeProperty('--vme-top');
        d.style.removeProperty('--vme-left');
        d.style.removeProperty('--vme-alto-max');
        d.style.removeProperty('--vme-flecha');
        return;
      }
      var ancho = caja.offsetWidth || 720;
      var vw = document.documentElement.clientWidth;
      var vh = window.innerHeight;
      var chip = document.querySelector('.hv__locale-boton');
      var ancla = abridor && abridor.classList && abridor.classList.contains('hv__locale-boton') ? abridor : chip;
      if (visible(ancla)) {
        var b = ancla.getBoundingClientRect();
        var cx = b.left + b.width / 2;
        var izq = Math.min(Math.max(24, cx - ancho / 2), vw - ancho - 24);
        var arriba = Math.round(b.bottom + 14);
        d.style.setProperty('--vme-top', arriba + 'px');
        d.style.setProperty('--vme-left', Math.round(izq) + 'px');
        d.style.setProperty('--vme-alto-max', Math.max(320, vh - arriba - 16) + 'px');
        d.style.setProperty('--vme-flecha', Math.round(cx - izq - 8) + 'px');
        d.classList.remove('vme--sin-flecha');
      } else {
        var tope = vh < 620 ? 16 : 96;
        d.style.setProperty('--vme-top', tope + 'px');
        d.style.setProperty('--vme-left', Math.max(24, Math.round((vw - ancho) / 2)) + 'px');
        d.style.setProperty('--vme-alto-max', (vh - tope - 16) + 'px');
        d.classList.add('vme--sin-flecha');
      }
    };

    var radios = function (grupo) {
      return Array.prototype.filter.call(grupo.querySelectorAll('[role="radio"]'), function (r) {
        return !r.hidden;
      });
    };

    var idiomasDe = function (pais) {
      var d = dialogo();
      if (!d) return [];
      var fila = pais ? d.querySelector('[data-vme-pais="' + pais + '"]') : null;
      var txt = fila ? fila.getAttribute('data-vme-idiomas') : d.getAttribute('data-vme-idiomas-actual');
      return (txt || '').split(',').filter(function (c) { return c !== ''; });
    };

    var ajustarIdiomas = function () {
      var d = dialogo();
      var grupo = d && d.querySelector('[data-vme-idiomas-grupo]');
      if (!grupo) return [];
      var botones = Array.prototype.slice.call(grupo.querySelectorAll('[data-vme-idioma]'));
      var pide = idiomasDe(borrador.pais);
      var vistos = [];
      var orden = [];
      pide.forEach(function (c) {
        for (var i = 0; i < botones.length; i++) {
          if (botones[i].getAttribute('data-vme-idioma') === c && orden.indexOf(botones[i]) === -1) {
            orden.push(botones[i]);
            vistos.push(c);
          }
        }
      });
      if (!vistos.length) {
        orden = botones.slice();
        vistos = botones.map(function (b) { return b.getAttribute('data-vme-idioma'); });
      }
      var n = vistos.length;
      botones.forEach(function (b) {
        if (orden.indexOf(b) === -1) orden.push(b);
      });
      var mover = orden.some(function (b, i) { return botones[i] !== b; });
      if (mover) orden.forEach(function (b) { grupo.appendChild(b); });
      orden.forEach(function (b, i) { b.hidden = i >= n; });
      grupo.classList.toggle('vme__idiomas--cuatro', n === 4);
      return vistos;
    };

    var idiomaDelPais = function (proponer) {
      var vistos = ajustarIdiomas();
      if (!vistos.length) return;
      var tiene = function (c) { return vistos.indexOf(c) !== -1; };
      if (proponer) {
        borrador.idioma = borrador.pais === guardado.pais && tiene(guardado.idioma) ? guardado.idioma : vistos[0];
      } else if (!tiene(borrador.idioma)) {
        borrador.idioma = vistos[0];
      }
    };

    var pintar = function () {
      var d = dialogo();
      if (!d) return;
      var idiomas = d.querySelectorAll('[data-vme-idioma]');
      var nombreIdioma = '';
      for (var i = 0; i < idiomas.length; i++) {
        var on = idiomas[i].getAttribute('data-vme-idioma') === borrador.idioma;
        idiomas[i].setAttribute('aria-checked', on ? 'true' : 'false');
        idiomas[i].tabIndex = on ? 0 : -1;
        if (on) nombreIdioma = idiomas[i].getAttribute('data-vme-idioma-nombre') || '';
      }
      var grupoIdiomas = d.querySelector('[data-vme-idiomas-grupo]');
      if (grupoIdiomas && !grupoIdiomas.querySelector('[data-vme-idioma][aria-checked="true"]:not([hidden])')) {
        var primerIdioma = radios(grupoIdiomas)[0];
        if (primerIdioma) primerIdioma.tabIndex = 0;
      }
      var paises = d.querySelectorAll('[data-vme-pais]');
      var fila = null;
      for (var j = 0; j < paises.length; j++) {
        var sel = paises[j].getAttribute('data-vme-pais') === borrador.pais;
        paises[j].setAttribute('aria-checked', sel ? 'true' : 'false');
        paises[j].tabIndex = sel ? 0 : -1;
        if (sel) fila = paises[j];
      }
      var lista = d.querySelector('[data-vme-lista]');
      if (lista && (!fila || fila.hidden)) {
        var primera = radios(lista)[0];
        if (primera) primera.tabIndex = 0;
      }
      var campoPais = d.querySelector('[data-vme-campo-pais]');
      var campoIdioma = d.querySelector('[data-vme-campo-idioma]');
      if (campoPais) campoPais.value = borrador.pais;
      if (campoIdioma) campoIdioma.value = borrador.idioma;
      if (fila) {
        var bandera = d.querySelector('[data-vme-resumen-bandera]');
        var rPais = d.querySelector('[data-vme-resumen-pais]');
        var rMoneda = d.querySelector('[data-vme-resumen-moneda]');
        if (bandera) bandera.style.backgroundImage = 'url(' + fila.getAttribute('data-vme-bandera') + ')';
        if (rPais) rPais.textContent = fila.getAttribute('data-vme-pais-nombre');
        if (rMoneda) rMoneda.textContent = fila.getAttribute('data-vme-moneda');
      }
      var rIdioma = d.querySelector('[data-vme-resumen-idioma]');
      if (rIdioma && nombreIdioma) rIdioma.textContent = nombreIdioma;
      var cta = d.querySelector('[data-vme-cta]');
      if (cta) {
        var igual = borrador.pais === guardado.pais && borrador.idioma === guardado.idioma;
        cta.disabled = igual;
        cta.textContent = cta.getAttribute(igual ? 'data-vme-texto-igual' : 'data-vme-texto-cambio');
      }
    };

    var filtrar = function (texto) {
      var d = dialogo();
      if (!d) return;
      var aguja = plano(texto).trim();
      var caja = d.querySelector('[data-vme-busca]');
      if (caja) caja.classList.toggle('vme__busca--con-texto', aguja !== '');
      var filas = d.querySelectorAll('[data-vme-pais]');
      var vistos = 0;
      for (var i = 0; i < filas.length; i++) {
        var cabe = aguja === '' || plano(filas[i].getAttribute('data-vme-buscar') || '').indexOf(aguja) !== -1;
        filas[i].hidden = !cabe;
        if (cabe) vistos++;
      }
      var grupos = d.querySelectorAll('[data-vme-grupo]');
      for (var g = 0; g < grupos.length; g++) grupos[g].hidden = aguja !== '';
      var res = d.querySelector('[data-vme-resultados]');
      if (res) res.hidden = aguja === '' || vistos === 0;
      var resN = d.querySelector('[data-vme-resultados-n]');
      if (resN) resN.textContent = vistos;
      var vacio = d.querySelector('[data-vme-vacio]');
      if (vacio) vacio.hidden = vistos !== 0;
      pintar();
    };

    var marcarAbridores = function (abierto) {
      var botones = document.querySelectorAll('[data-vme-abrir]');
      for (var i = 0; i < botones.length; i++) botones[i].setAttribute('aria-expanded', abierto ? 'true' : 'false');
    };

    var abrir = function () {
      var d = dialogo();
      if (!d || d.open) return;
      guardado.pais = d.getAttribute('data-vme-pais-actual') || '';
      guardado.idioma = d.getAttribute('data-vme-idioma-actual') || '';
      borrador.pais = guardado.pais;
      borrador.idioma = guardado.idioma;
      idiomaAMano = false;
      idiomaDelPais(false);
      var campo = d.querySelector('[data-vme-filtro]');
      if (campo) campo.value = '';
      filtrar('');
      try {
        d.showModal();
      } catch (e) {
        return;
      }
      colocar();
      marcarAbridores(true);
      if (!escritorio.matches) {
        overflowPrevio = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      var lista = d.querySelector('[data-vme-lista]');
      var sel = lista && lista.querySelector('[data-vme-pais][aria-checked="true"]');
      if (lista) {
        lista.scrollTop = 0;
        if (sel) {
          var bajo = sel.getBoundingClientRect().bottom - lista.getBoundingClientRect().bottom;
          if (bajo > 0) lista.scrollTop = bajo + 60;
        }
      }
      if (campo && escritorio.matches && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        try {
          campo.focus({ preventScroll: true });
        } catch (e) {}
      }
    };

    var alCerrar = function () {
      marcarAbridores(false);
      if (overflowPrevio !== null) {
        document.documentElement.style.overflow = overflowPrevio;
        overflowPrevio = null;
      }
    };

    var tecladoReciente = false;
    document.addEventListener('keydown', function () { tecladoReciente = true; }, true);
    document.addEventListener('pointerdown', function () { tecladoReciente = false; }, true);

    var marcarFoco = function (el) {
      if (!el || el === document.body || !el.setAttribute) return;
      el.setAttribute('data-vme-foco-toque', '');
      var quitar = function () {
        el.removeAttribute('data-vme-foco-toque');
        el.removeEventListener('blur', quitar);
        el.removeEventListener('keydown', quitar);
      };
      el.addEventListener('blur', quitar);
      el.addEventListener('keydown', quitar);
    };

    var cerrar = function () {
      var d = dialogo();
      if (d && d.open) {
        d.close();
        if (!tecladoReciente) marcarFoco(document.activeElement);
      }
      alCerrar();
    };

    var elegir = function (radio, conFoco) {
      if (!radio) return;
      if (radio.hasAttribute('data-vme-idioma')) {
        borrador.idioma = radio.getAttribute('data-vme-idioma');
        idiomaAMano = true;
      } else if (radio.hasAttribute('data-vme-pais')) {
        var antes = borrador.pais;
        borrador.pais = radio.getAttribute('data-vme-pais');
        idiomaDelPais(!idiomaAMano && borrador.pais !== antes);
      }
      pintar();
      if (conFoco) {
        try {
          radio.focus({ preventScroll: false });
        } catch (e) {}
      }
    };

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var boton = t.closest('[data-vme-abrir]');
      if (boton) {
        e.preventDefault();
        abridor = boton;
        if (boton.hasAttribute('data-vme-abrir-menu') && typeof window.__veeryTrasCerrarMenu === 'function') {
          window.__veeryTrasCerrarMenu(abrir);
        } else {
          abrir();
        }
        return;
      }

      var d = dialogo();
      if (!d || !d.contains(t)) return;

      if (t.closest('[data-vme-cerrar]')) {
        cerrar();
        return;
      }

      if (t.closest('[data-vme-limpiar]')) {
        var campo = d.querySelector('[data-vme-filtro]');
        if (campo) {
          campo.value = '';
          filtrar('');
          try {
            campo.focus({ preventScroll: true });
          } catch (err) {}
        }
        return;
      }

      var radio = t.closest('[data-vme-idioma], [data-vme-pais]');
      if (radio) {
        var lista = d.querySelector('[data-vme-lista]');
        var arriba = lista ? lista.scrollTop : 0;
        elegir(radio, false);
        if (lista) lista.scrollTop = arriba;
        return;
      }

      if (t === d) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      var d = dialogo();
      if (!d || !d.open || !d.contains(e.target)) return;
      if (e.target.hasAttribute && e.target.hasAttribute('data-vme-filtro') && e.key === 'Enter') {
        e.preventDefault();
        return;
      }
      var radio = e.target.closest && e.target.closest('[role="radio"]');
      if (!radio) return;
      var grupo = radio.closest('[data-vme-grupo-radios]');
      if (!grupo) return;
      var todos = radios(grupo);
      var i = todos.indexOf(radio);
      var j = -1;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') j = (i + 1) % todos.length;
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') j = (i - 1 + todos.length) % todos.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = todos.length - 1;
      else if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        elegir(radio, true);
        return;
      }
      if (j < 0) return;
      e.preventDefault();
      elegir(todos[j], true);
    });

    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-vme-filtro')) filtrar(t.value);
    });

    document.addEventListener('submit', function (e) {
      var d = dialogo();
      if (!d || !d.contains(e.target)) return;
      if (borrador.pais === guardado.pais && borrador.idioma === guardado.idioma) e.preventDefault();
    });

    document.addEventListener('close', function (e) {
      if (e.target && e.target.id === 'veery-mercado') alCerrar();
    }, true);

    window.addEventListener('resize', function () {
      var d = dialogo();
      if (d && d.open) colocar();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veery-tabla-tallas"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function iniciar(caja) {
    if (caja.__vttListo) return;
    caja.__vttListo = true;

    var ambito = caja.closest('[data-vtt-ambito]') || document.body;
    var filas = caja.querySelectorAll('[data-vtt-talla]');
    var escala = function () { return ambito.querySelector('[data-vesc]'); };

    function aplica(est) {
      if (!est) return;
      if (est.unidad === 'cm' || est.unidad === 'in') ambito.setAttribute('data-unidad', est.unidad);
      var talla = String(est.talla || '').toLowerCase();
      for (var i = 0; i < filas.length; i++) {
        var on = String(filas[i].getAttribute('data-vtt-talla')).toLowerCase() === talla;
        filas[i].classList.toggle('is-activa', on);
        var b = filas[i].querySelector('[data-vtt-elegir]');
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    ambito.addEventListener('vesc:estado', function (ev) {
      var es = escala();
      if (!es || ev.target === es) aplica(ev.detail);
    });

    for (var k = 0; k < filas.length; k++) {
      filas[k].addEventListener('click', function () {
        var es = escala();
        if (es && es.__vesc) es.__vesc.fijar(this.getAttribute('data-vtt-talla'));
      });
    }

    var es = escala();
    if (es && es.__vesc && es.__vesc.estado) aplica(es.__vesc.estado());
  }

  function escanear() {
    var cajas = document.querySelectorAll('[data-vtt]');
    for (var i = 0; i < cajas.length; i++) iniciar(cajas[i]);
  }

  window.VeeryTablaTallas = { escanear: escanear };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', escanear);
  else escanear();
  document.addEventListener('shopify:section:load', escanear);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veery-tarjeta-linea"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__veeryTarjetaMoneda) return;
    window.__veeryTarjetaMoneda = true;

    function raiz() {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }

    function secciones() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        var id = c.dataset ? c.dataset.sectionId : '';
        if (id && ids.indexOf(id) < 0) ids.push(id);
      });
      return ids;
    }

    function pedir(ruta, cuerpo) {
      return fetch(raiz() + ruta, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok || !j || j.status) {
            var fallo = new Error(ruta);
            fallo.detalle = r.status === 422 && j ? j : null;
            throw fallo;
          }
          return j;
        });
      });
    }

    function diferida(m) {
      try {
        if (m) return m.CartLinesUpdateEvent.createPromise();
      } catch (e) {}
      var d = {};
      d.promise = new Promise(function (si, no) { d.resolve = si; d.reject = no; });
      return d;
    }

    function aviso(m, datos) {
      try {
        if (m) return new m.CartLinesUpdateEvent(datos);
      } catch (e) {}
      var ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true });
      for (var k in datos) ev[k] = datos[k];
      return ev;
    }

    function estandar(m, carrito) {
      if (!m || !carrito) return carrito || null;
      try { return m.CartLinesUpdateEvent.createCartFromAjaxResponse(carrito); } catch (e) { return null; }
    }

    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-vtl-cambiar]') : null;
      if (!b) return;
      e.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;

      var nueva = b.getAttribute('data-vtl-nueva');
      var clave = b.getAttribute('data-vtl-clave');
      var cantidad = parseInt(b.getAttribute('data-vtl-cantidad'), 10) || 1;
      var propiedades = {};
      try { propiedades = JSON.parse(b.getAttribute('data-vtl-propiedades') || '{}') || {}; } catch (err) { propiedades = {}; }
      var caja = b.closest('.vtl__moneda');
      var error = caja ? caja.querySelector('[data-vtl-error]') : null;
      var texto = b.textContent;
      var anadida = false;

      b.setAttribute('aria-busy', 'true');
      b.textContent = b.getAttribute('data-vtl-cambiando') || texto;
      if (error) error.hidden = true;

      var m = (window.VeeryCarrito && window.VeeryCarrito.eventos) || null;
      var promesa = diferida(m);
      document.dispatchEvent(aviso(m, {
        action: 'update',
        context: 'cart',
        lines: [{ id: String(clave), quantity: 0 }],
        promise: promesa.promise
      }));

      pedir('cart/add.js', { items: [{ id: Number(nueva), quantity: cantidad, properties: propiedades }] })
        .then(function () {
          anadida = true;
          return pedir('cart/change.js', { id: clave, quantity: 0, sections: secciones().join(',') });
        })
        .then(function (carrito) {
          promesa.resolve({
            cart: estandar(m, carrito),
            detail: {
              items: carrito.items,
              source: 'veery-tarjeta-moneda',
              itemCount: cantidad,
              variantId: Number(nueva),
              sections: carrito.sections,
              didError: false
            }
          });
          if (!carrito.sections) window.location.reload();
        })
        .catch(function (fallo) {
          if (anadida) {
            window.location.reload();
            return;
          }
          var parada = new Error('veery-tarjeta-moneda');
          parada.name = 'AbortError';
          promesa.reject(parada);
          b.removeAttribute('aria-busy');
          b.textContent = texto;
          if (error) {
            var porDefecto = b.getAttribute('data-vtl-error-texto') || '';
            error.textContent = window.VeeryCarrito && window.VeeryCarrito.textoError
              ? window.VeeryCarrito.textoError(fallo && fallo.detalle, porDefecto)
              : porDefecto;
            error.hidden = false;
          }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
